import { TooltipProvider } from "@app/ui";
import { ClerkProvider, Show } from "@clerk/react";
import { RouterProvider } from "react-router";
import { AppCssBaseLine } from "./css-baseline/app-css-baseline";
import { ErrorBoundary } from "./error/error-boundary";
import { RouterPrivate } from "./router-private";
import { RouterPublic } from "./router-public";
import { SnackbarList } from "./snackbar/snackbar-list";
import { AppThemeProvider } from "./theme/app-theme-provider";
import { HasOrganization } from "./user/has-organization";

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
	throw new Error("Missing Clerk Publishable Key");
}

export const App = () => {
	return (
		<ErrorBoundary>
			<ClerkProvider
				publishableKey={PUBLISHABLE_KEY}
				afterSignOutUrl="/"
				telemetry={false}
			>
				<AppThemeProvider>
					<TooltipProvider>
						<AppCssBaseLine />
						<Show when="signed-out">
							<ErrorBoundary>
								<RouterProvider router={RouterPublic} />
							</ErrorBoundary>
						</Show>
						<Show when="signed-in">
							<HasOrganization>
								<ErrorBoundary>
									<RouterProvider router={RouterPrivate} />
								</ErrorBoundary>
							</HasOrganization>
						</Show>
						<SnackbarList />
					</TooltipProvider>
				</AppThemeProvider>
			</ClerkProvider>
		</ErrorBoundary>
	);
};
